import React, { useRef, useEffect } from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/landing/primitives";

const LICENSE = "IAWG8UP3R473DF35";

const buildSrc = (lang) => {
  const params = new URLSearchParams({
    lic: LICENSE,
    origin: "dr-file.de",
    theme: "custom",
    make: "Audi",
    model: "A7",
    gen: "4G 2010 - 2014",
    engine: "3.0 TDI Bi-Turbo 313hp",
    lang: lang || "de",
    bg: "transparent",
    text: "#ffffff",
    accent: "#00ff1e",
    pulse: "#44ff00",
    pulseOff: "0",
    dyno: "1",
    dynoBg: "#0a0a0a",
    dynoText: "#ffffff",
    dynoAccent: "#00ff2a",
  });
  return `https://konf.dr-file.de/index.php?${params.toString()}`;
};

const Configurator = () => {
  const { lang, t } = useLang();
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    iframe.src = buildSrc(lang);

    const onMessage = (e) => {
      if (e.data?.type === "resize" && e.data.height) {
        iframe.style.height = e.data.height + "px";
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [lang]);

  const c = t.configurator;

  return (
    <section
      id="configurator"
      className="relative bg-[#121212] px-5 py-24 md:px-10 md:py-32"
      data-testid="configurator-section"
    >
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <Overline color="red">{c.overline}</Overline>
          <h2 className="mt-5 max-w-3xl font-display text-5xl font-black leading-[0.95] text-white md:text-7xl">
            {c.title}
          </h2>
          <p className="mt-6 max-w-2xl text-base text-white/60 md:text-lg">
            {c.subtitle}
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-14 border-l-4 border-brand-green bg-[#0A0A0A] p-4 md:p-8">
            <div className="mb-4 flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-white/40">
              <span className="h-2 w-2 animate-pulse rounded-full bg-brand-green" />
              live
            </div>
            <iframe
              ref={iframeRef}
              id="fahrzeug-konfigurator"
              title="Fahrzeug Konfigurator"
              scrolling="no"
              loading="lazy"
              style={{
                width: "100%",
                maxWidth: "1200px",
                margin: "0 auto",
                border: "none",
                display: "block",
                height: "180px",
              }}
              data-testid="configurator-iframe"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Configurator;
